module.exports = __webpack_public_path__ + "static/media/star_118.b6b6a325.png";